import { DeepReadonly } from 'utility-types';
import { createSelector } from 'reselect';
import { ReduxState } from '../../state';
import { INITIAL_STATE } from './reducers';
import {
  IdentityProviderData,
  SamlIdentityProviderPreLoginState,
} from './types';

export const selectSamlIdentityProviderPreLogin = (
  state: ReduxState
): SamlIdentityProviderPreLoginState =>
  state.SamlIdentityProviderPreLogin || INITIAL_STATE;

export const selectSamlSsoCohort = createSelector(
  selectSamlIdentityProviderPreLogin,
  (samlIdpPreLogin): string | null => samlIdpPreLogin.cohortId
);

export const selectSamlIdProviders = createSelector(
  selectSamlIdentityProviderPreLogin,
  (samlIdpPreLogin): DeepReadonly<IdentityProviderData[]> =>
    samlIdpPreLogin.idpCandidates
);
